import React from 'react'
import { inject, observer } from 'mobx-react'
import { FREE_CHAT_WINDOW_DURATION_SECONDS, formatFreeChatWindowClock } from 'core/freeChatWindow'

// AVN-1396: header shows the clock inside the ring, the minimized bar a small ring beside it.
const SIZES = {
  header: { size: 40, stroke: 3 },
  compact: { size: 18, stroke: 2.5 },
}

/**
 * AVN-1396 free chat window countdown, drawn as a ring that empties as the window runs out. Display only: the end time
 * comes from the server, and FreeChatWindowTimer is what ticks the clock and fires the expiry popup.
 */
const FreeChatWindowRing = ({ store, size = 'header', className = '' }) => {
  if (!store.freeChatWindowActive) {
    return null
  }

  const { size: px, stroke } = SIZES[size]
  const radius = (px - stroke) / 2
  const circumference = 2 * Math.PI * radius
  const left = Math.min(1, store.freeChatWindowSecondsLeft / FREE_CHAT_WINDOW_DURATION_SECONDS)
  const clock = formatFreeChatWindowClock(store.freeChatWindowSecondsLeft)

  return (
    <div className={`ccp-fcw-ring ccp-fcw-ring--${size} ${className}`} title="Free chat window">
      <svg width={px} height={px} viewBox={`0 0 ${px} ${px}`} aria-hidden="true">
        <circle className="ccp-fcw-ring__track" cx={px / 2} cy={px / 2} r={radius} strokeWidth={stroke}/>
        <circle
          className="ccp-fcw-ring__progress"
          cx={px / 2}
          cy={px / 2}
          r={radius}
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - left)}
          transform={`rotate(-90 ${px / 2} ${px / 2})`}
        />
      </svg>
      <span className="ccp-fcw-ring__clock">{clock}</span>
    </div>
  )
}

export default inject('store')(observer(FreeChatWindowRing))
